import useStore from "components/ui/Context"
import { Modal } from "components/ui"
import { useRouter } from "next/router"
import { useEffect } from "react"
import Image from "next/image"

export default function ModalLive() {
  const router = useRouter()
  const { modalLive, setModalLive } = useStore()
  const { show, info } = modalLive

  function onClose() {
    setModalLive({
      show: false,
      info: {}
    })
  }

  useEffect(() => {
    onClose()
  }, [router])

  return (
    <Modal isOpen={show} onCancel={onClose} showIcon={false}>
      <div className="flex flex-col items-center px-10 pt-[30px] pb-8 gap-6 bg-[#1A1A1A] w-[358px]">
        <Image src="/logoOnliveTV.png" width={85} height={36} alt="" />
        <div className="">
          {/* {!isVod && info?.home_name ? (
            <span>
              Sự kiện {info?.home_name} - {info?.away_name}
            </span>
          ) : (
            <span>{info?.name || info?.title}</span>
          )}
          <br /> */}
          {info?.status === "finish" ? (
            <div className="flex flex-col gap-2 items-center">
              <div className="flex flex-col gap-0.5 items-center">
                <span className="font-semibold text-lg leading-6 text-[#fafaf9]">Sự kiện đã kết thúc</span>
                <span className="font-normal text-base leading-5 text-[#AFAFAF] text-center">
                  Vui lòng thưởng thức nội dung khác
                </span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-2 items-center">
              <div className="flex flex-col gap-0.5 items-center">
                <span className="font-normal text-lg leading-6 text-[#fafaf9]">Sự kiện sẽ diễn ra vào lúc: </span>
                <span className="font-semibold text-lg leading-6 text-[#fafaf9]">{renderTime(info?.start_time)}</span>
              </div>
              <span className="font-normal text-base leading-5 text-[#AFAFAF]">Bật thông báo để theo dõi sự kiện</span>
            </div>
          )}
        </div>
        <button
          onClick={onClose}
          className="rounded-xl bg-[#2E2E2E] px-7 py-3 gap-2 font-bold text-[#fafaf9] text-sm w-full border border-[#3A3A3A]"
        >
          Đóng
        </button>
      </div>
    </Modal>
  )
}
function renderTime(string) {
  if (!string) return
  const date = new Date(string)
  const minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
  return (
    <span>
      {date.getHours()}:{minute} ngày {date.getDate()}/{date.getMonth() + 1}
    </span>
  )
}
